import React from 'react'

function UhmFooter() {
    return (
        <div>
            <img src="https://www.uhm.com/images/uhm/uhm-logo-color.png" alt="Union Home Mortgage logo" />
        </div>
    )
}

export default UhmFooter;